
export class TablePage {
	public content: any[];
	public numberOfElements: number;
	public totalElements: number;
	public pageable: any;

	public constructor(page?: any) {
		if (page) {
			this.content = page.content;
			this.numberOfElements = page.numberOfElements;
			this.totalElements = page.totalElements;
			this.pageable = page.pageable;
		}
	}
}
